import React, { Component } from 'react'
import './Recommandations.scss'

export default class Recommendations extends Component {
    render() {
        return (
            <div className="recommandations" >
            </div>
        )
    }
}
